module.exports = __webpack_public_path__ + "br.d01c375d42313e4075d8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/br.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/br.svg
// module chunks = styles